<template>
  <div>
    <el-card class="content" ref="calendarTest">
      <el-row>
        <el-col :span="19">
          <div style="margin:5px 15px 10px 5px"> <span style="font-size:30px;font-weight:600">{{ currentYear }}
            </span>{{
              $t("message.calendar.year") }}</div>
        </el-col>
        <el-col :span="5">
          <el-button-group>
            <el-button size="small" @click="currentYear--" icon="el-icon-arrow-left"></el-button>
            <el-button size="small" @click="getNow">{{ $t("message.calendar.currentYear") }}</el-button>
            <el-button size="small" @click="currentYear++" icon="el-icon-arrow-right"></el-button>
          </el-button-group>
        </el-col>

      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" v-for="o in 12" :key="o">
          <el-card shadow="hover" class="card">
            <div style="margin-left:18px;">
              <span style="font-size:18px;font-weight:600">{{ o }}</span> {{ $t("message.calendar.month") }}
            </div>
            <el-calendar v-model="monthVal[o - 1]" ref="calendar" class="cal">
              <template slot="dateCell" slot-scope="{ data }">
                <div class="calendar-cell" :class="getCalendarClassName(data)"
                  @contextmenu.prevent="openMenu($event, data)" :title="data.day">
                  {{
                    data.day.split("-").slice(2).join()
                  }}
                </div>
              </template>
            </el-calendar>
          </el-card>

        </el-col>
      </el-row>
    </el-card>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="getFlag">{{ setUnusal }} <span style="font-weight:600">{{ unusualDay }}</span></li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      datePick: "",
      workDayList: [],
      holidayList: [],
      monthVal: [],
      numList: [],
      flagList: [],
      currentYear: new Date().getFullYear(),
      visible: false,
      top: 0,
      left: 0,
      ttop: 0,
      unusualDay: '',
      setUnusal: '',
      selectDay: {},
    };
  },
  methods: {
    getNow() {
      this.currentYear = new Date().getFullYear();
    },

    getCalendarClassName(data) {
      // console.log(this.flagList);
      // const isFlag = this.flagList.includes(data.day) ? 'isFlag' : '';
      // const weekendOrWorkday = [0, 6].includes(new Date(data.day).getDay()) ? 'weekend wordDay' : 'holiDay';
      // return isFlag + " " + weekendOrWorkday;
      const flags = {
        isFlag: this.flagList.includes(data.day),
          weekend: [0, 6].includes(new Date(data.day).getDay()),
          workDay: [0, 6].includes(new Date(data.day).getDay()),
          holiDay: ![0, 6].includes(new Date(data.day).getDay()),
      };
      console.log(flags);
      return flags;
    },

    getFlag() {
      // console.log(e);
      let e = this.selectDay;
      let isFlag = this.flagList.includes(e.day);
      e.type = ![0, 6].includes(new Date(e.day).getDay()) ? 1 : 2;
      let date = JSON.parse(JSON.stringify(new Date(e.day)))
      if (isFlag) {
        axios.get('/ppm/calendar/deleteCalendarException?exceptionDate=' + date).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            const n = this.flagList.findIndex(i => i == e.day);
            this.flagList.splice(n, 1)
            // list.splice(n,1);
            // this.$store.commit('setCalendar',list)
          }
        })

      } else {
        axios.post('/ppm/calendar/saveCalendarException', {
          exceptionDate: date,
          exceptionType: e.type
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.flagList.push(e.day);
            // list.push({exceptionDate: date,exceptionType: e.type})
            // this.$store.commit('setCalendar',list)
          }
        })
      }
    },

    openMenu(e, item) {
      console.log(item);
      this.selectDay = item;
      this.unusualDay = this.flagList.includes(item.day) ? '' : [0, 6].includes(new Date(item.day).getDay()) ? '工作日' : '假日'
      this.setUnusal = this.flagList.includes(item.day) ? '取消设定' : '设定为';

      let elm = this.$refs.calendarTest.$parent.$parent._vnode.elm;
      let offsetLeft = elm.offsetLeft, offsetTop = elm.offsetTop, scrollTop = elm.scrollTop, scrollleft = elm;
      this.top = e.pageY - offsetTop + scrollTop;
      this.left = e.pageX - offsetLeft;
      this.visible = true;
    },
    closeMenu() {
      this.visible = false;
    },
    async getCalendar() {
      const { data: calendar } = await this.$http.get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear());
      this.flagList = calendar.object.map(i => i.exceptionDate.split('T')[0])
    },
  },
  created() {
    this.getCalendar();
    this.numList = Array(12).fill().map((_, e) => (e + 1));
    this.monthVal = this.numList.map(i => this.currentYear + '-' + i)
  },

  computed: {
    isWeekend(e) {
      return [0, 6].includes(new Date(e).getDay())
    }
  },
  watch: {
    currentYear(e) {
      this.monthVal = this.numList.map(i => e + '-' + i);
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  }
};
</script>

<style lang="scss">
.calendar-cell {
  border-radius: 2px;
  /* background: #1989fa; */
  width: 28px;
  height: 28px;
  line-height: 28px;
  margin: auto;
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

.calendar-cell:hover {
  background: #ebeef5;
}

.calendar-cell.isSelected {
  color: #fff;
  background: #1989fa;
  border-radius: 3px;
}

.calendar-cell.isSelected:hover {
  background: #1989fa;
}

.calendar-cell.weekend {
  background: #a0cfff;
}

.current .isFlag.workDay {
  /* color: #fff; */
  background: #fff;
}

.current .isFlag.holiDay {
  /* color: #fff; */
  background: #a0cfff;
}

.cc {
  display: inline-block;
  width: 19%;
  margin: 0 5px;
}

.content .el-card__body {
  padding: 15px 20px 35px 20px;
}

.card .el-card__body {
  padding: 10px;
}

.cal .el-calendar__body {
  padding: 0 10px;
}

.cal .el-calendar-table {
  font-size: 14px;
}

.cal .el-calendar__header {
  display: none;
}

.cal .el-calendar-table tr td:first-child {
  border: none;
}

.cal .el-calendar-table tr:first-child td {
  border: none;
}

.cal .el-calendar-table .el-calendar-day {
  font-size: 14px;
  text-align: center;
  border-radius: 3px;
  padding: 0;
  height: 37px;
  line-height: 37px;
  background: none;
  /* height: 40px;
  line-height: 40px; */
}

.cal .el-calendar-table .el-calendar-day:hover {
  background: none;
}

.cal .el-calendar-table td {
  border: none;
  /* background: #ebeef5; */
  background: none;
}

/* .cal .el-calendar-table td .cell {
  border: none;
  background: #fff;
} */
/* background: red;
} */

.cal .el-calendar-table:not(.is-range) td.prev {
  pointer-events: none;
  /* background: none !important; */
  /* color: #303133 !important; */
}

.cal .el-calendar-table:not(.is-range) td.next {
  pointer-events: none;
  /* background: none !important; */
  /* color: #303133 !important; */
}
</style>
<style scoped>
.card {
  margin: 5px 0px;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 400;
  color: #606266;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: #EBEEF5;
}
</style>
